import { IconChartHistogram, IconCoin, IconHeartHandshake, IconZoomMoney } from '@tabler/icons-react';
import KeyStatsCardWithIcon from 'components/KeyStatsCardWithIcon/KeyStatsCardWithIcon';
import { Col, Row } from 'reactstrap';
import { IAggregateReportKeyStats } from 'views/Reports/types';
import { numeralFormatterCurrency } from 'ns_libs/formatter';

export interface IAggregateReportKeyStatsProps {
    keyStats: IAggregateReportKeyStats;
}
const AggregateReportKeyStats = ({ keyStats }: IAggregateReportKeyStatsProps) => (
    <>
        <Row className="d-flex mt-2 mb-0 pb-0 justify-content-between">
            <Col xs="4" className="pr-0 pb-0 mb-0">
                <KeyStatsCardWithIcon
                    title="LEVERED IRR"
                    value={keyStats.leveredIrr || '-'}
                    isPercentage
                    icon={IconChartHistogram}
                    cardClassname="mb-2 mt-2"
                />
            </Col>
            <Col xs="4" className="pr-0 pb-0 mb-0">
                <KeyStatsCardWithIcon
                    title="LEVERED EMx"
                    value={keyStats.leveredEmx ? `${keyStats.leveredEmx.toFixed(2)}x` : '-'}
                    icon={IconZoomMoney}
                    cardClassname="mb-2 mt-2"
                />
            </Col>
            <Col xs="4" className="pb-0 mb-0">
                <KeyStatsCardWithIcon
                    title="STABILIZED YIELD-ON-COST"
                    value={keyStats.stabilizedYieldOnCost || '-'}
                    isPercentage
                    icon={IconCoin}
                    cardClassname="mb-2 mt-2"
                />
            </Col>
        </Row>
        <Row className="d-flex mt-0 pt-0 justify-content-between">
            <Col xs="4" className="pr-0 pt-0 mt-0">
                <KeyStatsCardWithIcon
                    title="NET PROFIT"
                    value={numeralFormatterCurrency(keyStats.netProfit, '$0,0') || '-'}
                    icon={IconCoin}
                    cardClassname="mb-3"
                />
            </Col>
            <Col xs="4" className="pr-0">
                <KeyStatsCardWithIcon
                    title="GENERAL PARTNER IRR"
                    value={keyStats.generalPartnerIrr || '-'}
                    isPercentage
                    icon={IconHeartHandshake}
                    cardClassname="mb-3"
                />
            </Col>
            <Col xs="4">
                <KeyStatsCardWithIcon
                    title="LIMITED PARTNER IRR"
                    value={keyStats.limitedPartnerIrr || '-'}
                    icon={IconHeartHandshake}
                    isPercentage
                    cardClassname="mb-3"
                />
            </Col>
        </Row>
    </>
);

export default AggregateReportKeyStats;
